require('../../search/_submit-index');

$(() => {
  function onShowVideoModal() {
    const html5Video = document.getElementById('htmlVideo');
    if (html5Video != null) {
      html5Video.pause();
      html5Video.currentTime = 0;
    }
  }

  $.post(loadNewsUrl, {}, (data) => {
    $('#news-list').html(data.html);
    $('#news-list a').attr('target', '_blank');
  });

  $('#html5Video').on('hidden.bs.modal', onShowVideoModal);
});
